import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { ConcursoFotografiasService, Fotografia, FotografiaPodio } from '../services/concurso-fotografias.service';

@Component({
  selector: 'app-votacao-fotografias',
  standalone: true,
  imports: [Button, Dialog],
  templateUrl: './votacao.html',
  styleUrl: './votacao.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VotacaoFotografiasComponent implements OnInit, OnDestroy {
  private readonly service = inject(ConcursoFotografiasService);
  protected readonly fotos = signal<Fotografia[]>([]);
  protected readonly podio = signal<FotografiaPodio[]>([]);
  protected readonly podioLiberado = signal(false);
  protected readonly carregando = signal(true);
  protected readonly visualizando = signal<Fotografia | null>(null);
  protected readonly erro = signal('');
  protected readonly votacaoAberta = signal(false);
  protected readonly enviando = signal(false);
  protected readonly votoRegistrado = signal<string | null>(null);
  protected readonly selecionada = signal<Fotografia | null>(null);

  async ngOnInit(): Promise<void> {
    try {
      const [fotos, podio, voto] = await Promise.all([this.service.listar(), this.service.podio(), this.service.meuVoto()]);
      this.fotos.set(fotos);
      this.votacaoAberta.set(voto.votacao_aberta);
      this.votoRegistrado.set(voto.fotografia_id);
      this.podioLiberado.set(podio.liberado);
      this.podio.set(podio.fotos);
    } catch (error) { this.erro.set(this.service.mensagemErro(error)); }
    finally { this.carregando.set(false); }
  }

  ampliar(foto: Fotografia): void { this.visualizando.set(foto); }

  confirmar(foto: Fotografia): void {
    if (this.votacaoAberta() && this.votoRegistrado() === null) this.selecionada.set(foto);
  }

  async votar(): Promise<void> {
    const foto = this.selecionada();
    if (!foto) return;
    this.enviando.set(true);
    this.erro.set('');
    try {
      await this.service.votar(foto.id);
      this.votoRegistrado.set(foto.id);
    } catch (error) { this.erro.set(this.service.mensagemErro(error)); }
    finally { this.selecionada.set(null); this.enviando.set(false); }
  }

  ngOnDestroy(): void {
    this.fotos().forEach(foto => foto.imagemUrl && URL.revokeObjectURL(foto.imagemUrl));
    this.podio().forEach(foto => foto.imagemUrl && URL.revokeObjectURL(foto.imagemUrl));
  }
}
